@if (guidedTour$ | async; as guidedTour) {
  <div class="guided-tour">
    <div class="progress">
      <div class="percentage">
        <h1 class="percentage-number">
          {{
            guidedTour.completedSections.length
              | percentage: guidedTour.sections.length
          }}
        </h1>
        <h5 class="percentage-unit">%</h5>
      </div>
      <markant-seperator
        class="progress-separator"
        orientation="vertical"
      ></markant-seperator>
      <div class="remaining-section">
        {{
          'platformWidget.guidedTour.' +
            (guidedTour.remainingSections.length > 1
              ? 'sectionsLeft'
              : 'sectionLeft')
            | transloco: { count: guidedTour.remainingSections.length }
        }}
      </div>
    </div>
    <markant-progress-bar
      buffer="1"
      progress="{{
        guidedTour.completedSections.length
          | percentage: guidedTour.sections.length : true
      }}"
    ></markant-progress-bar>
    <div class="section-links">
      <ng-container *ngFor="let section of guidedTour.sections; let i = index">
        <a
          class="link"
          [ngClass]="
            (guidedTour.completedSections | arrayIncludes: section)
              ? 'finished-section'
              : 'unfinished-section'
          "
          (click)="startGuidedTour(i + 1)"
        >
          <markant-icon
            [class.hide-finished-icon]="
              !(guidedTour.completedSections | arrayIncludes: section)
            "
            icon="m_checkmark-small"
          ></markant-icon>
          <h6 class="link-text">
            {{
              i +
                1 +
                '. ' +
                ('platformWidget.guidedTour.' + guidedTour.id + '.' + section
                  | transloco)
            }}
          </h6>
          <markant-icon
            class="arrow-icon"
            icon="m_arrow-right-small"
          ></markant-icon>
        </a>
      </ng-container>
    </div>
  </div>
}
